import React from 'react';
import { User, Users, Home, Hotel } from 'lucide-react';

interface Client {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

interface RoomAssignment {
  id: number;
  client: Client;
}

interface Room {
  id: number;
  type: string;
  capacity: number;
  assignments: RoomAssignment[];
}

interface AcceptedClientsRoomsListProps {
  rooms: Room[];
}

export default function AcceptedClientsRoomsList({ rooms }: AcceptedClientsRoomsListProps) {
  // Logs pour déboguer
  
  // Compter le nombre total d'assignations
  const totalAssignments = rooms.reduce((total, room) => total + room.assignments.length, 0);

  // Fonction pour obtenir l'icône et le nom du type de chambre
  const getRoomTypeInfo = (type: string) => {
    const typeMap = {
      'SINGLE': { icon: <Home className="w-5 h-5" />, label: 'Simple' },
      'DOUBLE': { icon: <Hotel className="w-5 h-5" />, label: 'Double' },
      'TRIPLE': { icon: <Hotel className="w-5 h-5" />, label: 'Triple' },
      'QUADRUPLE': { icon: <Hotel className="w-5 h-5" />, label: 'Quadruple' },
      'QUINTUPLE': { icon: <Hotel className="w-5 h-5" />, label: 'Quintuple' },
      'SUITE': { icon: <Hotel className="w-5 h-5" />, label: 'Suite' },
    };
    
    return typeMap[type] || { icon: <Home className="w-5 h-5" />, label: type };
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium">Clients par chambre</h3>
      
      {rooms.length === 0 ? (
        <p className="text-gray-500">Aucune chambre assignée pour cette offre.</p>
      ) : (
        <div className="space-y-4">
          {rooms.map(room => {
            const { icon, label } = getRoomTypeInfo(room.type);
            
            return (
              <div key={room.id} className="bg-gray-50 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-3">
                  {icon}
                  <h4 className="font-medium">Chambre {label} (capacité: {room.capacity})</h4>
                </div>
                
                {room.assignments.length === 0 ? (
                  <p className="text-gray-500">Aucun client assigné à cette chambre.</p>
                ) : (
                  <div className="space-y-3">
                    {room.assignments.map(assignment => (
                      <div key={assignment.id} className="flex items-center gap-3 p-2 bg-white rounded border border-gray-200">
                        <div className="bg-blue-100 p-2 rounded-full">
                          <User className="w-5 h-5 text-blue-600" />
                        </div>
                        <div>
                          <p className="font-medium">{assignment.client.firstName} {assignment.client.lastName}</p>
                          <p className="text-sm text-gray-500">{assignment.client.email}</p>
                          <p className="text-sm text-gray-500">{assignment.client.phone}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
} 